import ConfigurationEmailSmtpForm from './configuration.email.smtp.form.model';
export default class ConfigurationEmailSmtpFormController {
	static $inject = [
		'$scope',
		'$state',
		'$stateParams',
		'ModalService',
		'ConfigurationEmailService',
		'notification',
		'$translate',
		'$filter',
		'_',
		'$uibModal'
	];
	constructor($scope, $state, $stateParams, ModalService, ConfigurationEmailService, notification, $translate, $filter, _, $uibModal) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.ModalService = ModalService;
		this.ConfigurationEmailService = ConfigurationEmailService;
		this.notification = notification;
		this.$translate = $translate;
		this.$filter = $filter;
		this._ = _;
		this.$uibModal = $uibModal;
		this.configurationSmtp = new ConfigurationEmailSmtpForm();
		this.loading = false;
		this.isEdit = false;
		this.typesSmtp = [
			{ value: 0, label: 'SMTP' },
			{ value: 1, label: 'Configuration Microsoft' },
			{ value: 2, label: 'Configuration Google' }
		];
	}

	async $onInit() {
		if (this.resolve.idSociete > 0) {
			this.configurationSmtp.idSociete = this.resolve.idSociete;
			await this.loadConfigurationSmtp(this.resolve.idSociete);
			if (this.configurationSmtp.id && this.configurationSmtp.id > 0) {
				this.isEdit = true;
			}
		}
	}

	async loadConfigurationSmtp(idSociete) {
		this.startLoading();
		try {
			const configSmtp = await this.ConfigurationEmailService.getConfigurationSmtpBySociete(idSociete);
			if (configSmtp) {
				this.configurationSmtp = new ConfigurationEmailSmtpForm(configSmtp);
			}
		} catch (error) {
			this.notification.error('CONFIGURATION_EMAIL.FORM.CONFIGURATION_NOT_FOUND');
		}
		this.stopLoading();
	}

	async save() {
		if (this.checkValidity()) {
			const form = {
				idSociete: this.configurationSmtp.idSociete,
				type: this.configurationSmtp.type,
				isConfigurationPortail: this.configurationSmtp.isConfigurationPortail,
				smtpLogin: this.configurationSmtp.smtpLogin,
				smtpPassFromServeur: this.configurationSmtp.smtpPassFromServeur,
				smtpPass: this.configurationSmtp.smtpPass,
				smtpServer: this.configurationSmtp.smtpServer,
				smtpPort: this.configurationSmtp.smtpPort,
				smtpAlias: this.configurationSmtp.smtpAlias,
				smtpIsSslConnection: this.configurationSmtp.smtpIsSslConnection,
				smtpIsTlsConnection: this.configurationSmtp.smtpIsTlsConnection,
				clientIdMSFromServeur: this.configurationSmtp.clientIdMSFromServeur,
				clientIdMS: this.configurationSmtp.clientIdMS,
				clientSecretMSFromServeur: this.configurationSmtp.clientSecretMSFromServeur,
				clientSecretMS: this.configurationSmtp.clientSecretMS,
				tenantIdMSFromServeur: this.configurationSmtp.tenantIdMSFromServeur,
				tenantIdMS: this.configurationSmtp.tenantIdMS,
				senderMail: this.configurationSmtp.senderMail,
				clientIdGoogleFromServeur: this.configurationSmtp.clientIdGoogleFromServeur,
				clientIdGoogle: this.configurationSmtp.clientIdGoogle,
				clientSecretGoogleFromServeur: this.configurationSmtp.clientSecretGoogleFromServeur,
				clientSecretGoogle: this.configurationSmtp.clientSecretGoogle,
				refreshTokenGoogleFromServeur: this.configurationSmtp.refreshTokenGoogleFromServeur,
				refreshTokenGoogle: this.configurationSmtp.refreshTokenGoogle
			};

			if (this.isEdit) {
				await this.ConfigurationEmailService.updateConfigurationEmailSmtp(this.configurationSmtp.id, form);
			} else {
				await this.ConfigurationEmailService.createConfigurationEmailSmtp(form);
			}
			this.notification.success('CONFIGURATION_EMAIL.FORM.CONFIGURATION_SAVED');
			this.ok();
		} else {
			return this.notification.error('CONFIGURATION_EMAIL.FORM.VALIDATION_ERROR');
		}
	}

	async testConfiguration() {
		if (this.checkValidity()) {
			var result = await this.ConfigurationEmailService.testConfiguration(this.configurationSmtp);
			if (result && result.data == '') {
				this.notification.success('CONFIGURATION_EMAIL.FORM.CONFIGURATION_TESTED');
			} else {
				this.notification.error(this.$translate.instant('CONFIGURATION_EMAIL.FORM_ERROR.' + result.data));
			}
		}
	}

	ok() {
		this.close({
			$value: this.configurationSmtp.id
		});
	}

	cancel() {
		this.dismiss();
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}

	unlockField(fieldName) {
		this.configurationSmtp[fieldName] = null;
		this.configurationSmtp[`${fieldName}FromServeur`] = false;
	}

	checkValidity() {
		let validity = true;
		if (!this.configurationSmtp.isValid()) {
			validity = false;
		}
		return validity;
	}
}
